var $ec276c10668cb27d$exports = {};
$ec276c10668cb27d$exports = {
    "clear": `Puhasta`,
    "invalid": `(kehtetu)`,
    "loading": `Laadimine...`,
    "noResults": `Tulemusi pole`,
    "valid": `(kehtiv)`
};


export {$ec276c10668cb27d$exports as default};
//# sourceMappingURL=et-EE.module.js.map
